'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _rollupPluginBabelHelpers = require('../../../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var classNames = _interopDefault(require('classnames/dedupe'));
var Icon = require('../../01.atoms/Icon/Icon.js');
require('./_index.scss.js');

var CLASSNAME = 'varta-bread-crumb',
    cnItem = "".concat(CLASSNAME, "__item"),
    cnItemLabel = "".concat(cnItem, "__label"),
    cnItemActive = "".concat(cnItem, "--active"),
    cnItemValid = "".concat(cnItem, "--valid"),
    cnItemError = "".concat(cnItem, "--error"),
    cnItemClickable = "".concat(cnItem, "--clickable"),
    cnIcon = "".concat(CLASSNAME, "__icon");
/**
 * 
 * @param {*} param0 
 * @returns 
 */

function BreadCrumb(_ref) {
  var activeStep = _ref.activeStep,
      items = _ref.items;
  var activeItem = React.useRef();
  var scrollWrapper = React.useRef();
  React.useEffect(function () {
    if (activeItem.current && scrollWrapper.current) {
      scrollActiveItemIntoView(activeItem.current, scrollWrapper.current);
    }
  }, [activeStep]);
  return /*#__PURE__*/React__default.createElement("ul", {
    className: CLASSNAME,
    ref: scrollWrapper
  }, items.filter(function (a) {
    return !!a;
  }).map(function (_ref2) {
    var _classNames;

    var title = _ref2.title,
        id = _ref2.id,
        valid = _ref2.valid,
        error = _ref2.error,
        onClick = _ref2.onClick;
    var active = activeStep === id;
    return /*#__PURE__*/React__default.createElement("li", {
      ref: active ? activeItem : null,
      key: id,
      className: classNames(cnItem, (_classNames = {}, _rollupPluginBabelHelpers.defineProperty(_classNames, cnItemActive, active), _rollupPluginBabelHelpers.defineProperty(_classNames, cnItemValid, valid), _rollupPluginBabelHelpers.defineProperty(_classNames, cnItemError, error), _rollupPluginBabelHelpers.defineProperty(_classNames, cnItemClickable, !!onClick), _classNames)),
      onClick: valid && onClick ? function (e) {
        return onClick(e, id);
      } : null
    }, (valid || error) && /*#__PURE__*/React__default.createElement(Icon, {
      className: cnIcon,
      id: error ? 'times' : 'check',
      size: "xxs"
    }), /*#__PURE__*/React__default.createElement("span", {
      className: cnItemLabel
    }, title));
  }));

  function scrollActiveItemIntoView(activeItem, scrollWrapper, center) {
    var _activeItem$getBoundi = activeItem.getBoundingClientRect(),
        left = _activeItem$getBoundi.left,
        top = _activeItem$getBoundi.top,
        width = _activeItem$getBoundi.width,
        height = _activeItem$getBoundi.height;

    var _scrollWrapper$getBou = scrollWrapper.getBoundingClientRect(),
        outerWidth = _scrollWrapper$getBou.width,
        outerHeight = _scrollWrapper$getBou.height,
        outerLeft = _scrollWrapper$getBou.left,
        outerTop = _scrollWrapper$getBou.top;

    var offsetTop = top - outerTop;
    var offsetLeft = left - outerLeft;
    var x = (outerWidth - width) / 2;
    var y = (outerHeight - height) / 2;

    if (center) {
      offsetLeft = offsetLeft - x;
      offsetTop = offsetTop - y;
    }

    scrollWrapper.scrollBy(offsetLeft, offsetTop);
  }
}
BreadCrumb.propTypes = {
  /** Should match id of active item */
  activeStep: PropTypes.string,

  /** Array of objects with display title and id required */
  items: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    valid: PropTypes.bool,
    error: PropTypes.bool,
    onClick: PropTypes.func
  })).isRequired
};
BreadCrumb.defaultProps = {
  items: []
};

module.exports = BreadCrumb;
